interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  const btnBase =
    'flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md px-2 text-sm font-medium transition-colors';

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btnBase} border border-background-200 bg-background-50 text-foreground-600 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-300 hover:text-primary-600`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btnBase} border border-background-200 bg-background-50 text-foreground-600 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-300 hover:text-primary-600`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}